import { useState } from "react";
import { checkEcoproSupportRegion, findzipCodeError } from "../../constants/AppMethod";
import { _API_ENDPOINT, SUCCESS } from "../../constants/AppConstants";
import { ENVSettings } from "../../constants/ENVSettings";
import { _CALLGETAPI } from "../../api/apiHandler";

const UsePostalCodeValidation = (country, postcode) => {
    const [postcodeLoader, setPostcodeLoader] = useState(false);

    const validateCountryPostCodeRestriction = async () => {
        try{
                const countryCode2 = ENVSettings.COUNTRIES.find(item => item.name === country);
                const endpoint = _API_ENDPOINT.COUNTRY_POST_CODE;
                const payload = {
                params: {
                    countryCode: countryCode2.code2
                }
            }
            return _CALLGETAPI(endpoint,payload).then((response) => {
                setPostcodeLoader(false);
                if(response?.actionStatus?.toUpperCase() === SUCCESS){
                    const isRegionNotSupportedForDelivery = checkEcoproSupportRegion(postcode,response.postCodes);
                    if(isRegionNotSupportedForDelivery){
                        return true;
                    }
                } else {
                    return false;
                }
            });
        } catch (e){
            throw e;
        }
    }

    const validatePostalCode = async () => {
        if(country && postcode){
            setPostcodeLoader(true);
            const isPostalCodeErr = findzipCodeError(country, postcode);
            if(isPostalCodeErr){
                setPostcodeLoader(false);
                return true;
            } else {
                return await validateCountryPostCodeRestriction();
            }
        }
    }
    return {
        postcodeLoader,
        setPostcodeLoader,
        validatePostalCode
    }
}

export default UsePostalCodeValidation;